import { render } from "./SquadMapBlock.vue?vue&type=template&id=453cd920"
import script from "./SquadMapBlock.vue?vue&type=script&lang=js"
export * from "./SquadMapBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__